import { useQuery } from "react-query";
import { useAccess, useAccountId } from "../Auth/auth-functions";
import { api } from "./api";
import { ProgramPromotionCode } from "../models/promotions.models";

export const useProgramPromotionCodesQuery = (programGroupId: number) => { 
	const hasAccess = useAccess("role.user.readonly");
	const accountId = useAccountId();

	return useQuery(['promotion-codes', programGroupId, accountId], async () => {
		let res = await api.get<ProgramPromotionCode[]>(`/admin/promotions/${programGroupId}`);
		return res.data;
	}, { staleTime: Infinity, cacheTime: 600000, enabled: hasAccess });
}
